import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Layout/Sidebar";
import Header from "../Layout/Header";
import "./ConflictOfInterestForm.css";

const ConflictOfInterestForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    project: "",
    declared_by: "",
    has_conflict: "",
    details: "",
    mitigation: "",
    status: "SUBMITTED",
    reviewed_by: "",
    reviewed_at: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.declared_by) {
      alert("Please select who is declaring the conflict.");
      return;
    }

    if (formData.has_conflict === "") {
      alert("Please specify whether a conflict exists.");
      return;
    }

    if (
      formData.has_conflict === "YES" &&
      !formData.details.trim()
    ) {
      alert("Please provide conflict details.");
      return;
    }

    console.log(
      "Conflict of Interest Declaration:",
      formData
    );

    alert(
      "Conflict of Interest declaration saved successfully."
    );
  };

  return (
    <div className="page-layout">
      <Sidebar />

      <div className="main-content">
        <Header />

        <div className="coi-page-container">
          {/* Page Header */}
          <div className="coi-page-header">
            <div>
             

              <h1>Conflict of Interest</h1>

              <p>
                Declare, manage and review potential conflicts
                of interest related to projects.
              </p>
            </div>
 <button
                type="button"
                className="coi-back-btn"
                onClick={() => navigate("/admin/projects")}
              >
                ← Back
              </button>
          </div>

          {/* Form */}
          <form
            className="coi-form-card"
            onSubmit={handleSubmit}
          >
            {/* Header */}
            <div className="coi-form-header">
              <div>
                <h2>Conflict of Interest Declaration</h2>

                <p>
                  Declare, manage and review potential
                  conflicts of interest related to projects.
                </p>
              </div>

              <span className="coi-status-badge">
                {formData.status}
              </span>
            </div>

            <div className="coi-form-body">
              {/* Declaration Information */}
              <div className="coi-section">
                <div className="coi-section-title">
                  <h3>Declaration Information</h3>

                  <p>
                    Identify the project and user making the
                    conflict declaration.
                  </p>
                </div>

                <div className="coi-grid">
                  <div className="coi-field">
                    <label>Project</label>

                    <select
                      name="project"
                      value={formData.project}
                      onChange={handleChange}
                    >
                      <option value="">
                        Select project
                      </option>

                      <option value="PROJECT-001">
                        Project Alpha
                      </option>

                      <option value="PROJECT-002">
                        Project Beta
                      </option>

                      <option value="PROJECT-003">
                        Project Gamma
                      </option>
                    </select>

                    <small>
                      Leave empty if the declaration is not
                      project-specific.
                    </small>
                  </div>

                  <div className="coi-field">
                    <label>
                      Declared By <span>*</span>
                    </label>

                    <select
                      name="declared_by"
                      value={formData.declared_by}
                      onChange={handleChange}
                      required
                    >
                      <option value="">
                        Select user
                      </option>

                      <option value="USER-001">
                        Project Manager
                      </option>

                      <option value="USER-002">
                        HR Manager
                      </option>

                      <option value="USER-003">
                        Organisation Admin
                      </option>
                    </select>
                  </div>

                  <div className="coi-field">
                    <label>
                      Conflict Exists <span>*</span>
                    </label>

                    <select
                      name="has_conflict"
                      value={formData.has_conflict}
                      onChange={handleChange}
                      required
                    >
                      <option value="">
                        Select
                      </option>

                      <option value="YES">
                        Yes
                      </option>

                      <option value="NO">
                        No
                      </option>
                    </select>
                  </div>

                  <div className="coi-field">
                    <label>Status</label>

                    <select
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option value="SUBMITTED">
                        Submitted
                      </option>

                      <option value="UNDER_REVIEW">
                        Under Review
                      </option>

                      <option value="RESOLVED">
                        Resolved
                      </option>

                      <option value="CLOSED">
                        Closed
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Conflict Details */}
              <div className="coi-section">
                <div className="coi-section-title">
                  <h3>Conflict Details</h3>

                  <p>
                    Provide details about the conflict and
                    how it is being managed.
                  </p>
                </div>

                <div className="coi-grid">
                  <div className="coi-field coi-full-field">
                    <label>Details</label>

                    <textarea
                      name="details"
                      value={formData.details}
                      onChange={handleChange}
                      placeholder="Describe the conflict of interest..."
                      rows="5"
                    />
                  </div>

                  <div className="coi-field coi-full-field">
                    <label>Mitigation</label>

                    <textarea
                      name="mitigation"
                      value={formData.mitigation}
                      onChange={handleChange}
                      placeholder="Describe how the conflict is being managed or mitigated..."
                      rows="5"
                    />
                  </div>
                </div>
              </div>

              {/* Review Information */}
              <div className="coi-section">
                <div className="coi-section-title">
                  <h3>Review Information</h3>

                  <p>
                    Capture the person who reviewed the
                    declaration and the review date.
                  </p>
                </div>

                <div className="coi-grid">
                  <div className="coi-field">
                    <label>Reviewed By</label>

                    <select
                      name="reviewed_by"
                      value={formData.reviewed_by}
                      onChange={handleChange}
                    >
                      <option value="">
                        Select reviewer
                      </option>

                      <option value="USER-001">
                        Organisation Admin
                      </option>

                      <option value="USER-002">
                        Compliance Manager
                      </option>

                      <option value="USER-003">
                        Project Manager
                      </option>
                    </select>
                  </div>

                  <div className="coi-field">
                    <label>Reviewed At</label>

                    <input
                      type="datetime-local"
                      name="reviewed_at"
                      value={formData.reviewed_at}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              {/* Information Box */}
              <div className="coi-info-box">
                <div className="coi-info-icon">
                  !
                </div>

                <div>
                  <strong>
                    Conflict of Interest Review
                  </strong>

                  <p>
                    A declaration should clearly identify
                    whether a conflict exists, document the
                    circumstances and capture the mitigation
                    approach where applicable. Review
                    information should only be completed by
                    the authorised reviewer.
                  </p>
                </div>
              </div>

              {/* Summary */}
              <div className="coi-summary">
                <div className="coi-summary-item">
                  <span>Project</span>

                  <strong>
                    {formData.project
                      ? formData.project
                      : "Not specified"}
                  </strong>
                </div>

                <div className="coi-summary-item">
                  <span>Conflict</span>

                  <strong>
                    {formData.has_conflict === "YES"
                      ? "Yes"
                      : formData.has_conflict === "NO"
                      ? "No"
                      : "Not selected"}
                  </strong>
                </div>

                <div className="coi-summary-item">
                  <span>Status</span>

                  <strong>
                    {formData.status}
                  </strong>
                </div>

                <div className="coi-summary-item">
                  <span>Review</span>

                  <strong>
                    {formData.reviewed_by
                      ? "Assigned"
                      : "Pending"}
                  </strong>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="coi-form-actions">
              <button
                type="button"
                className="coi-cancel-btn"
                onClick={() =>
                  navigate("/admin/projects")
                }
              >
                Cancel
              </button>

              <button
                type="submit"
                className="coi-save-btn"
              >
                Save Declaration
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ConflictOfInterestForm;